export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as getPolicyKey, initialState as getPolicyInitialState, State as GetPolicyState } from './reducer';

export {
  getData as getPolicyGetData,
  getError as getPolicyGetError,
  getLoading as getPolicyGetLoading,
  mapData as getPolicyMapData,
} from './selectors';
